// Sprint 8.D + Session 2A (v6) — Zentrale Copy-Konstanten für die User-Facing-Bezeichnung
// der Flexpfad-Bibliothek.
// User-Facing-Strings umbenannt auf „Flexpfad" / „Flexpfad-Bibliothek" / „Flexpfad-Explorer".
// DB-Collections, Backend-Felder + Tests bleiben unverändert (Naming-Freeze für Code/DB AKTIV).

export const COPY = {
  // Hauptbezeichnung Bibliothek
  libraryTitle: {
    pro: "Deine Flexpfad-Bibliothek",
    free: "Deine gespeicherten Flexpfade",
    readOnly: "Deine Flexpfad-Bibliothek (Read-Only)",
  },
  // Cockpit-Header H1
  cockpitHeaderH1: {
    pro: "Du gehst deinen Flexpfad",
    free: "Du entdeckst deinen Flexpfad",
    readOnly: "Deine Flexpfad-Bibliothek (Read-Only)",
  },
  // CTA / Section-Titel
  savedLibrarySectionTitle: {
    pro: "Meine Flexpfad-Bibliothek",
    free: "Meine gespeicherten Flexpfade",
  },
  // Saved-Library Counter-Suffix
  entryWord: {
    one: "Eintrag",
    many: "Einträge",
  },
};

// Helper: tier → key resolver
export function libraryLabel({ isPro, isReadOnly = false }) {
  if (isReadOnly) return COPY.libraryTitle.readOnly;
  return isPro ? COPY.libraryTitle.pro : COPY.libraryTitle.free;
}

export function savedSectionTitle({ isPro }) {
  return isPro ? COPY.savedLibrarySectionTitle.pro : COPY.savedLibrarySectionTitle.free;
}
